import { Loader2 } from 'lucide-react';
import { cn } from './cn';

/**
 * Vídeo da OS no painel e no backoffice, com o que o servidor sabe dele
 * (`os_media.processing`/`poster_s3_key` — ver `apps/api/src/lib/video-process.ts`):
 *
 * - `processing`: o vídeo da galeria está sendo convertido. O original pode
 *   ser HEVC, que o Chrome não toca na maior parte das máquinas — no lugar de
 *   um player preto, o aviso. Quem mostra recarrega a lista enquanto houver
 *   vídeo nesse estado.
 * - pôster: a miniatura sem baixar o vídeo (`preload="none"`). Sem pôster
 *   (vídeo antigo), `preload="metadata"` como sempre foi.
 */
export function MediaVideo({
  url,
  posterUrl,
  processing,
  className,
  placeholderClassName,
}: {
  url: string;
  posterUrl?: string | null;
  processing?: string | null;
  className?: string;
  /** Cores do aviso "processando" — cada app usa as suas. */
  placeholderClassName?: string;
}) {
  if (processing === 'processing') {
    return (
      <div
        role="status"
        className={cn('flex h-full w-full flex-col items-center justify-center gap-1 p-2 text-center text-xs', placeholderClassName)}
      >
        <Loader2 size={18} className="animate-spin" aria-hidden />
        <span>Preparando o vídeo…</span>
      </div>
    );
  }
  return (
    <video
      src={url}
      poster={posterUrl ?? undefined}
      className={className}
      controls
      preload={posterUrl ? 'none' : 'metadata'}
    />
  );
}
